import type { Icon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { cx } from "@/lib/cx";

export type BadgeTone = "neutral" | "accent" | "danger" | "warning" | "success";

const tones: Record<BadgeTone, string> = {
  neutral: "bg-hover text-fg-muted",
  accent: "bg-accent-soft text-accent-soft-fg",
  danger: "bg-danger-soft text-danger-soft-fg",
  warning: "bg-warning-soft text-warning-soft-fg",
  success: "bg-success-soft text-success-soft-fg",
};

export function Badge({
  tone = "neutral",
  icon: I,
  children,
  className,
  numeric,
}: {
  tone?: BadgeTone;
  icon?: Icon;
  children: ReactNode;
  className?: string;
  /**
   * Counts use tabular figures so they do not shift width as they change. Sans, not mono: the
   * badge usually carries words too ("3 failed in a row"), and mono words read as code.
   */
  numeric?: boolean;
}) {
  return (
    <span
      className={cx(
        "inline-flex h-5 max-w-full shrink-0 items-center gap-1 rounded-mark px-1.5 text-xs font-medium whitespace-nowrap",
        numeric && "tnum",
        tones[tone],
        className,
      )}
    >
      {I ? <I size={12} aria-hidden="true" className="shrink-0" /> : null}
      <span className="truncate-title">{children}</span>
    </span>
  );
}
